import { Spinner } from 'spin.js';

function show_validations_modal(pmp_id, record_type, column) {
  $.ajax({
    type: 'get',
    async: false,
    dataType: 'html',
    url: 'pmps/validation_rules/edit_validation',
    data: 'pmp_id=' + pmp_id + '&model_class=' + record_type + '&attribute_name=' + column,
    success: function (data) {
      const existingModalElement = document.getElementById('validations_modal');
      if (existingModalElement) {
        const existingInstance = bootstrap.Modal.getInstance(existingModalElement);
        if (existingInstance) existingInstance.dispose();
      }
      $('#modal_div').html(data);
      modalInstance('validations_modal').show();
    }
  });
}

function modalInstance(modal_id) {
  const modalElement = document.getElementById(modal_id);
  return bootstrap.Modal.getOrCreateInstance(modalElement);
}

function validateTypes(results, formId) {
  let identity = '';
  let failoverIdentity = '';

  if (formId === 'prescriber_identifier_type_form') {
    identity = $('#prescriber_identifier_type').val();
    failoverIdentity = $('#prescriber_identifier_failover_type').val();
  } else if (formId === 'dispensary_identifier_type_form') {
    identity = $('#dispensary_identifier_type').val();
    failoverIdentity = $('#dispensary_identifier_failover_type').val();
  }

  if (identity === failoverIdentity) {
    results.addClass('text-danger');
    results.text("Identifier Type and Identifier Failover Type can't be the same");
    results.delay(4600).fadeOut('slow');
    return false
  } else {
    return true
  }
}

function initializeValidationsPageBehavior() {
  $(document)
    .off('click.pmpValidations', '.validation-modal')
    .on('click.pmpValidations', '.validation-modal', function () {
      let pmp_id = $(this).data('pmp-id');
      let record_type = $(this).data('rec-type');
      let column = $(this).data('rec-attr');
      $('.modal-backdrop').remove();
      show_validations_modal(pmp_id, record_type, column);
    });

  $(".ddv_toggle_checkbox").each(function () {
    if ($(this).data('bootstrap-switch')) return;
    $(this).bootstrapSwitch({
      'size': 'mini',
      'onSwitchChange': function (event, state) {
        $("#" + event.target.id).closest('.ddv_toggle_control').siblings('.ddv_toggle_target').toggleClass('d-none');
      },
    });
  });

  $(document)
    .off('ajax:success.pmpValidations', 'a.reset_link')
    .on('ajax:success.pmpValidations', 'a.reset_link', function (event, data) {
      if (!data || typeof data !== 'object') return;
      if (data.status === 'success') {
        $('div.success_msg').html("<div class='alert alert-success'><button type='button' class='custom-close' data-bs-dismiss='alert'>&times;</button><h5>" + data.msg + "</h5></div>");
      } else if (data.msg) {
        $('div.errors_msg').html("<div class='alert alert-danger'><button type='button' class='custom-close' data-bs-dismiss='alert'>&times;</button><h5>" + data.msg + "</h5></div>");
      }
    });

  const firstAccordionToggle = $('.accordion-toggle').first();
  if (firstAccordionToggle.length && !firstAccordionToggle.data('pmp-validations-auto-opened')) {
    firstAccordionToggle.data('pmp-validations-auto-opened', true).click();
  }

  $('.accordion')
    .off('show.pmpValidations hide.pmpValidations')
    .on('show.pmpValidations hide.pmpValidations', function (n) {
      $(n.target).siblings('.accordion-heading').find('.accordion-toggle i').toggleClass('fa-chevron-up fa-chevron-down');
      $(n.target).siblings('.accordion-heading').toggleClass('show-border hide-border');
    });

  $('#accordion3')
    .off('show.pmpValidations hide.pmpValidations')
    .on('show.pmpValidations hide.pmpValidations', function (n) {
      $(n.target).siblings('.accordion-heading').find('.accordion-toggle i').toggleClass('fa-chevron-up fa-chevron-down')
      $(n.target).siblings('.accordion-heading').toggleClass('show-border hide-border');
    });

  $(document)
    .off('submit.pmpValidations', '#dispensary_identifier_type_form, #prescriber_identifier_type_form')
    .on('submit.pmpValidations', '#dispensary_identifier_type_form, #prescriber_identifier_type_form', function (event) {
      let form = $(this);
      let results = form.find(".identifier-type-results");
      results.text('');
      results.show();
      results.removeClass('text-success');
      results.removeClass('text-danger');

      if (validateTypes(results, this.id) === false) {
        event.preventDefault();
        return false;
      }

      let spinnerClass = form.find('.spinner');
      const spinner = new Spinner({ radius: 4, width: 2 }).spin();
      spinner.el.setAttribute('aria-label', 'Loading');
      spinnerClass.prepend(spinner.el);

      $.post(form.attr('action'), form.serialize(), function (data) {
        setTimeout(function () {
          spinner.stop();
          spinnerClass.html('');
          if (data.success != undefined) {
            window.location.replace(data.success);
          } else {
            results.addClass('text-danger');
            results.html(data.error.join("<br>"));
          }
          results.delay(4600).fadeOut('slow');
        }, 500);

      });

      event.preventDefault();
    });
}

$(initializeValidationsPageBehavior);
$(document).ajaxComplete(initializeValidationsPageBehavior);
